import React from "react";
import "./index.scss";

export const LikeIcon = ({active}) => {
    let className = "like-icon icon-fill icon-active-fill";
    if (active) {
        className += " active";
    }

    return (
        <svg className={className} width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.333252 15.2501C0.333252 15.9404 0.892896 16.5001 1.58325 16.5001C2.27361 16.5001 2.83325 15.9404 2.83325 15.2501V7.75006C2.83325 7.05971 2.27361 6.50007 1.58325 6.50007C0.892896 6.50007 0.333252 7.05971 0.333252 7.75007V15.2501ZM13.2878 6.50007H9.91645C9.25213 6.50007 8.77247 5.86427 8.95488 5.22549L9.93517 1.79257C10.0245 1.47978 9.99175 1.14473 9.8435 0.855182C9.69525 0.565624 9.44259 0.343174 9.13659 0.232816C8.56753 0.0275631 7.93394 0.269468 7.64647 0.80174L4.74017 6.18298C4.58248 6.47494 4.49992 6.80156 4.49992 7.13338V14.5001C4.49992 15.6046 5.39535 16.5001 6.49992 16.5001H11.8397C12.057 16.5001 12.2646 16.4104 12.4135 16.2522C14.0602 14.4806 14.9689 12.1475 14.9542 9.72892V8.16675C14.9542 7.72475 14.7786 7.30087 14.4661 6.98831C14.1536 6.67576 13.7298 6.50013 13.2878 6.50007Z" fill="white" />
        </svg>
    );
}

export const FavoriteIcon = ({active}) => {
    let className = "favorite-icon icon-stroke icon-active-stroke";
    if (active) {
        className += " active";
    }
    return (
        <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.64234 3.71663C9.78994 3.42252 10.2097 3.42252 10.3573 3.71663L11.7052 6.40224C11.938 6.86614 12.3814 7.18828 12.8945 7.26635L15.8652 7.71832C16.1905 7.76782 16.3202 8.16707 16.0861 8.39833L13.9485 10.5101C13.5792 10.8749 13.4099 11.3961 13.4942 11.9083L13.9823 14.8732C14.0358 15.1979 13.6962 15.4447 13.4039 15.2935L10.7349 13.913C10.2739 13.6746 9.72581 13.6746 9.26478 13.913L6.59579 15.2935C6.30351 15.4447 5.96389 15.1979 6.01734 14.8732L6.50548 11.9083C6.5898 11.3961 6.42044 10.8749 6.05119 10.5101L3.91353 8.39833C3.67943 8.16707 3.80915 7.76782 4.13448 7.71832L7.10515 7.26635C7.61829 7.18828 8.06168 6.86614 8.2945 6.40224L9.64234 3.71663Z" stroke="white" strokeWidth="1.2" />
        </svg>
    );
}

export const EpisodeExpandIcon = ({active}) => {
    let className = "episode-expand-icon icon-fill";
    if (active) {
        className += " active";
    }

    return (
        <svg className={className} width="6" height="7" viewBox="0 0 6 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.13414 5.66667C2.51904 6.33334 3.48129 6.33334 3.86619 5.66667L5.74258 2.41667C6.12748 1.75001 5.64635 0.916671 4.87655 0.916671H1.12378C0.353976 0.916671 -0.127151 1.75 0.257749 2.41667L2.13414 5.66667Z" fill="white" />
        </svg>
    );
}

export const PinIcon = ({active}) => {
    let className = "pin-icon icon-fill icon-active-fill";
    if (active) {
        className += " active";
    }

    return (
        <svg className={className} width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.7101 1.12549C10.4252 0.84058 9.96328 0.84058 9.67837 1.12549C9.5781 1.22572 9.51244 1.35531 9.49084 1.49542L9.40225 2.07068C9.36989 2.28084 9.27137 2.47522 9.12101 2.62558L6.1262 5.62045C5.88978 5.85687 5.55084 5.9595 5.22297 5.89393L4.09044 5.66742C3.87526 5.62443 3.65278 5.63521 3.44277 5.69882C3.23276 5.76242 3.04168 5.87687 2.8865 6.03202C2.49653 6.42186 2.49648 7.05403 2.88638 7.44394L4.53751 9.09511C4.92804 9.48565 4.92802 10.1188 4.53747 10.5094L0.863966 14.1825C0.737534 14.3089 0.666504 14.4804 0.666504 14.6592V14.674C0.666504 15.0381 0.961667 15.3333 1.32577 15.3333C1.50061 15.3333 1.66829 15.2638 1.79193 15.1402L5.48026 11.452C5.87079 11.0615 6.50394 11.0615 6.89446 11.452L8.54551 13.1031C8.93534 13.493 9.5674 13.493 9.95724 13.1031C10.1124 12.9479 10.2269 12.7567 10.2905 12.5467C10.3541 12.3366 10.3649 12.1141 10.3218 11.8989L10.0953 10.7663C10.0298 10.4385 10.1324 10.0995 10.3688 9.86309L13.3637 6.86825C13.514 6.71789 13.7084 6.61937 13.9186 6.58701L14.4938 6.49842C14.634 6.47685 14.7635 6.41119 14.8638 6.31095C15.1487 6.026 15.1487 5.56405 14.8637 5.27912L10.7101 1.12549Z" fill="white" />
        </svg>
    );
}

export const PreloaderIcon = ({color}) => {
    return (
        <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="17.5017" cy="7.61874" r="3.85714" transform="rotate(-120 17.5017 7.61874)" fill={color} fillOpacity="0.4"/>
            <ellipse cx="4.92103" cy="24.0133" rx="3.85714" ry="3.85714" transform="rotate(-165 4.92103 24.0133)" fill={color} fillOpacity="0.4"/>
            <circle cx="7.61386" cy="44.4991" r="3.85714" transform="rotate(150 7.61386 44.4991)" fill={color} fillOpacity="0.4"/>
            <ellipse cx="24.0123" cy="57.079" rx="3.85714" ry="3.85714" transform="rotate(105 24.0123 57.079)" fill={color} fillOpacity="0.4"/>
            <circle cx="44.4983" cy="54.3832" r="3.85714" transform="rotate(60 44.4983 54.3832)" fill={color} fillOpacity="0.4"/>
            <ellipse cx="57.0751" cy="37.9887" rx="3.85714" ry="3.85714" transform="rotate(15 57.0751 37.9887)" fill={color} fillOpacity="0.4"/>
            <circle cx="54.3822" cy="17.5031" r="3.85714" transform="rotate(-30 54.3822 17.5031)" fill={color} fillOpacity="0.4"/>
            <ellipse cx="37.9877" cy="4.92298" rx="3.85714" ry="3.85714" transform="rotate(-75 37.9877 4.92298)" fill={color} fillOpacity="0.4"/>
        </svg>
    );
}
